import {
  Modal,
  PrimaryButton,
  SecondaryButton,
  useTranslation,
} from '@testsigma/atoms';
import { useState } from 'react';
import { AppSigningHeader } from './components/app-signing-header';
import { AppExecuteChoose } from './components/app-execute-choose';
import { ProvisionSelectionComponent } from './components/provision-selection-component';
import { WdaSelectionCompoent } from './components/wda-selection-component';
import UploadService from '@services/uploads.service';
import { IosRealDevice } from '@models/ios-real-device.model';

type IosAppSigningModalType = {
  isOpen: boolean;
  setIsOpen: Function;
  id: number;
  uploadId: number;
  onSuccess: Function;
  isUpdate: boolean;
  wdaId: number;
  setWdaId: Function;
};
export const IosAppSigningModal = (props: IosAppSigningModalType) => {
  const [radio, setRadio] = useState<string>('webdriver');
  const [wdaSelected, setWdaSelection] = useState<number>(null);
  const [provisionCreated, setProvisionCreated] = useState<boolean>(false);
  const isdisabled = () => {
    if (radio == 'webdriver')
      if (wdaSelected == null) return true;
      else return false;
    else radio == 'provision';
    if (!provisionCreated) return true;
    else false;
  };
  const onSubmit = () => {
    const iosRealdevice = new IosRealDevice();
    iosRealdevice.id = props.id;
    if (radio == 'webdriver') {
      iosRealdevice.wdaId = wdaSelected;
      iosRealdevice.profileType = 'WDA_PROFILE';
    } else {
      iosRealdevice.wdaId = null;
      iosRealdevice.profileType = 'PROVISIONING_PROFILE';
    }
    UploadService.createIosRealDevice(iosRealdevice).then(() => {
      props.onSuccess();
    });
  };
  const onCancel = () => {
    props.onSuccess();
  };

  const { t } = useTranslation();
  return (
    <Modal
      isOpen={props.isOpen}
      className={'!rounded-xl px-8 py-6 w-[600px] h-[596px] flex flex-col'}
      closeOnEscape={false}
      closeOnOutsideClick={false}
      zIndex={5000}
      showCloseButton={false}>
      <div className='flex flex-col gap-6 flex-grow'>
        <AppSigningHeader
          setOpen={props.setIsOpen}
          onSuccess={props.onSuccess}
          id={props.uploadId}
          isUpdate={props.isUpdate}
          onCancel={onCancel}
        />
        <AppExecuteChoose radio={radio} setRadio={setRadio} />
        {radio == 'provision' && (
          <ProvisionSelectionComponent
            id={props.uploadId}
            setProvisonCreated={setProvisionCreated}
          />
        )}
        {radio == 'webdriver' && (
          <WdaSelectionCompoent
            setwdaSelection={setWdaSelection}
            wdaId={props.wdaId}
            setWdaId={props.setWdaId}
          />
        )}
      </div>
      <div className='pr-8 py-6 flex flex-row gap-4 justify-start'>
        <PrimaryButton onClick={onSubmit} isDisabled={isdisabled()}>
          {t('upload.iosapp.button.addnow')}
        </PrimaryButton>
        <SecondaryButton onClick={onCancel}>
          {t('upload.iosapp.button.cancel')}
        </SecondaryButton>
      </div>
    </Modal>
  );
};
